<template>
  <v-dialog v-model="visible" persistent max-width="1000">
    <v-card class="pa-5 rounded-lg">
      <v-btn @click="visible = false" x-small icon class="float-right">
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-text class="subtitle-2 px-0 font-weight-regular">
        <v-icon class="mr-2">table_chart</v-icon>
        Format
      </v-card-text>
      <v-form
        id="form"
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="exportRecap()"
      >
        <v-divider class="mb-2" />
        <v-radio-group v-model="format" mandatory>
          <v-row>
            <v-col
              cols="3"
              class="pb-0"
              v-for="(item, index) in formats"
              :key="index"
            >
              <v-radio
                :value="item.value"
                class="font-weight-regular"
                hide-details
              >
                <template #label>
                  <span class="subtitle-2 font-weight-regular">{{
                    item.label
                  }}</span>
                </template>
              </v-radio>
            </v-col>
          </v-row>
          <v-row class="mt-4">
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayUnit"
            >
              <v-autocomplete
                :items="units"
                v-model="unit"
                :loading="loadingUnit"
                placeholder="Unit Utama"
                outlined
                dense
                hide-details
                item-text="singkatan"
                item-value="unit_utama_id"
                clearable
                @change="changeUnit(1)"
                @click:clear="changeUnit(1)"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayUnit"
            >
              <v-autocomplete
                :items="units2"
                v-model="unit2"
                :loading="loadingUnit"
                placeholder="Unit Kerja"
                outlined
                dense
                hide-details
                item-text="singkatan"
                item-value="unit_kerja_2_id"
                clearable
                @change="changeUnit(2)"
                @click:clear="changeUnit(2)"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayUnit"
            >
              <v-autocomplete
                :items="units3"
                v-model="unit3"
                :loading="loadingUnit"
                placeholder="Unit Kerja"
                outlined
                dense
                hide-details
                item-text="singkatan"
                item-value="unit_kerja_3_id"
                clearable
                @change="changeUnit(3)"
                @click:clear="changeUnit(3)"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayUnit"
            >
              <v-autocomplete
                :items="units4"
                v-model="unit4"
                :loading="loadingUnit"
                placeholder="Unit Kerja"
                outlined
                dense
                hide-details
                item-text="singkatan"
                item-value="unit_kerja_4_id"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayDate"
            >
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    placeholder="Tanggal"
                    append-icon="event"
                    outlined
                    dense
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  type="month"
                  locale="id"
                  no-title
                  scrollable
                  @input="menu = false"
                />
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayKelompok"
            >
              <v-autocomplete
                placeholder="Kelompok Jabatan"
                v-model="kelompok"
                :items="kelompokList"
                :loading="loadingKelompok"
                outlined
                dense
                hide-details
                clearable
                item-text="nama_kel_jabatan"
                item-value="kel_jabatan_id"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayPeriod"
            >
              <v-autocomplete
                placeholder="Periode"
                v-model="period"
                :items="periodList"
                outlined
                dense
                hide-details
                clearable
                item-text="label"
                item-value="value"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayDetail"
            >
              <v-autocomplete
                placeholder="Detail"
                v-model="detail"
                :items="detailList"
                outlined
                dense
                hide-details
                clearable
                item-text="label"
                item-value="value"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayEducationPeriod"
            >
              <v-autocomplete
                placeholder="Periode Pendidikan"
                v-model="educationPeriod"
                :items="educationPeriodList"
                outlined
                dense
                hide-details
                clearable
                item-text="label"
                item-value="value"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayPendidikan"
            >
              <v-autocomplete
                placeholder="Pendidikan"
                v-model="pendidikan1"
                :loading="loadingPendidikan"
                :items="pendidikanList"
                outlined
                dense
                hide-details
                clearable
                item-text="nama_pend"
                item-value="kode_pend"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="12"
              class="my-0"
              v-if="displayPendidikan"
            >
              <v-autocomplete
                placeholder="Pendidikan"
                v-model="pendidikan2"
                :loading="loadingPendidikan"
                :items="pendidikanList"
                outlined
                dense
                hide-details
                clearable
                item-text="nama_pend"
                item-value="kode_pend"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-radio-group>
        <v-card-actions class="mt-3" v-if="displayExport">
          <v-spacer />
          <v-btn
            small
            color="success"
            class="px-12 subtitle-2 text-capitalize"
            :loading="formLoading"
            type="submit"
            :disabled="!valid"
            form="form"
            >Export</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import DataUtamaService from "@/services/resources/data.utama.service";
import RekapitulasiService from "@/services/resources/rekapitulasi.service";

export default {
  data() {
    return {
      formLoading: false,
      loadingUnit: false,
      loadingKelompok: false,
      loadingPendidikan: false,
      visible: false,
      valid: false,
      format: null,
      formats: [
        { label: "Kenaikan Pangkat", value: "Kenaikan Pangkat" },
        { label: "Masa Kerja", value: "Masa Kerja" },
        { label: "Pendidikan", value: "Pendidikan" },
        { label: "Golongan", value: "Golongan" },
        { label: "Jenis Kelamin", value: "Jenis Kelamin" },
        { label: "Kebutuhan Pegawai", value: "Kebutuhan Pegawai" },
        { label: "Eselon", value: "Eselon" }
      ],
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      unit: null,
      unit2: null,
      unit3: null,
      unit4: null,
      units: [],
      units2: [],
      units3: [],
      units4: [],
      kelompok: null,
      kelompokList: [],
      period: "all",
      periodList: [
        { label: "Semua", value: "all" },
        { label: "Sekarang", value: "now" },
        { label: "Sebelumnya", value: "before" }
      ],
      detail: "Y",
      detailList: [
        { label: "Ya", value: "Y" },
        { label: "Tidak", value: "N" }
      ],
      educationPeriod: "All",
      educationPeriodList: [
        { label: "Semua", value: "All" },
        { label: "Unit Kerja", value: "unit_kerja" },
        { label: "Kelompok Pendidikan", value: "kelompok_pend" },
        { label: "Jenis Pendidikan", value: "jk" }
      ],
      pendidikan1: null,
      pendidikan2: null,
      pendidikanList: []
    };
  },
  computed: {
    displayExport() {
      return (
        this.format == "Masa Kerja" ||
        this.format == "Kenaikan Pangkat" ||
        this.format == "Golongan" ||
        this.format == "Jenis Kelamin" ||
        this.format == "Kebutuhan Pegawai" ||
        this.format == "Eselon" ||
        this.format == "Pendidikan"
      );
    },
    displayUnit() {
      return (
        this.format == "Masa Kerja" ||
        this.format == "Kenaikan Pangkat" ||
        this.format == "Golongan" ||
        this.format == "Jenis Kelamin" ||
        this.format == "Kebutuhan Pegawai" ||
        this.format == "Eselon" ||
        this.format == "Pendidikan"
      );
    },
    displayDate() {
      return (
        this.format == "Masa Kerja" ||
        this.format == "Kenaikan Pangkat" ||
        this.format == "Golongan" ||
        this.format == "Jenis Kelamin" ||
        this.format == "Kebutuhan Pegawai" ||
        this.format == "Eselon" ||
        this.format == "Pendidikan"
      );
    },
    displayKelompok() {
      return (
        this.format == "Masa Kerja" ||
        this.format == "Kenaikan Pangkat" ||
        this.format == "Golongan" ||
        this.format == "Jenis Kelamin" ||
        this.format == "Kebutuhan Pegawai" ||
        this.format == "Eselon" ||
        this.format == "Pendidikan"
      );
    },
    displayDetail() {
      return this.format == "Eselon";
    },
    displayPeriod() {
      return (
        this.format == "Kenaikan Pangkat" ||
        this.format == "Golongan" ||
        this.format == "Jenis Kelamin"
      );
    },
    displayEducationPeriod() {
      return this.format == "Pendidikan";
    },
    displayPendidikan() {
      return this.format == "Pendidikan";
    }
  },
  methods: {
    change(flag) {
      this.visible = flag;
    },
    changeUnit(type = 2) {
      if (type == 1) {
        this.units2 = this.units.find(
          d => d.unit_utama_id == this.unit
        )?.unit_kerja2;
        this.unit2 = null;
        this.unit3 = null;
        this.unit4 = null;
      } else if (type == 2) {
        this.units3 = this.units2.find(
          d => d.unit_kerja_2_id == this.unit2
        )?.unit_kerja3;
        this.unit3 = null;
        this.unit4 = null;
      } else if (type == 3) {
        this.units4 = this.units3.find(
          d => d.unit_kerja_3_id == this.unit3
        )?.unit_kerja4;
        this.unit4 = null;
      }
    },
    populateUnit() {
      this.units2 = this.units.find(d =>
        d.unit_utama_id.includes(this.unit)
      )?.unit_kerja2;
      this.units3 = this.units2.find(
        d => d.unit_kerja_2_id == this.unit2
      )?.unit_kerja3;
      this.units4 = this.units3.find(
        d => d.unit_kerja_3_id == this.unit3
      )?.unit_kerja4;
    },
    exportRecap() {
      if (this.$refs.form.validate()) {
        this.exportFormat();
      }
    },
    // Service
    async getListUnit() {
      try {
        this.loadingUnit = true;
        await DataUtamaService.getUnitKerjaAll()
          .then(response => {
            const { status, data } = response.data;
            if (status) {
              this.units = data;
              this.populateUnit();
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingUnit = false));
      } catch (err) {
        console.error(err);
      }
    },
    async getKelompokJabatanListAll() {
      try {
        this.loadingKelompok = true;
        await DataUtamaService.getKelompokJabatanListAll()
          .then(response => {
            const { status, data } = response.data;
            if (status) {
              this.kelompokList = data;
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingKelompok = false));
      } catch (err) {
        console.error(err);
      }
    },
    async getPendidikanList() {
      try {
        this.loadingPendidikan = true;
        await DataUtamaService.getPendidikanList({
          filter: {
            search: "",
            pend_level_id: ""
          },
          orderBy: ["pend_level", "asc"],
          pageCurrent: 1,
          dataPerPage: 1000
        })
          .then(response => {
            const { status, data } = response.data;
            const { list } = data;
            if (status) {
              this.pendidikanList = list;
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingPendidikan = false));
      } catch (err) {
        console.error(err);
      }
    },
    async exportFormat() {
      let serviceAPI = RekapitulasiService.exportNaikPangkat;
      if (this.format == "Masa Kerja") {
        serviceAPI = RekapitulasiService.exportMasaKerja;
      } else if (this.format == "Pendidikan") {
        serviceAPI = RekapitulasiService.exportPendidikan;
      } else if (this.format == "Golongan") {
        serviceAPI = RekapitulasiService.exportGolongan;
      } else if (this.format == "Jenis Kelamin") {
        serviceAPI = RekapitulasiService.exportKelamin;
      } else if (this.format == "Kebutuhan Pegawai") {
        serviceAPI = RekapitulasiService.exportKebutuhanPegawai;
      } else if (this.format == "Eselon") {
        serviceAPI = RekapitulasiService.exportEselon;
      }

      try {
        this.loadingExport = true;
        await serviceAPI({
          unit_utama: this.displayUnit ? this.unit || "All" : undefined,
          unit_kerja_2_id: this.displayUnit ? this.unit2 || "All" : undefined,
          unit_kerja_3_id: this.displayUnit ? this.unit3 || "All" : undefined,
          unit_kerja_4_id: this.displayUnit ? this.unit4 || "All" : undefined,
          kelompok: this.displayKelompok ? this.kelompok || "All" : undefined,
          bulan: this.displayDate
            ? this.date
              ? this.$moment(this.date).format("MM")
              : ""
            : undefined,
          tahun: this.displayDate
            ? this.date
              ? this.$moment(this.date).format("YYYY")
              : ""
            : undefined,
          periode: this.displayPeriod ? this.period : undefined,
          detail: this.displayDetail ? this.detail : undefined,
          periodependidikan: this.displayEducationPeriod
            ? this.educationPeriod
            : undefined,
          pendidikan1: this.displayPendidikan ? this.pendidikan1 : undefined,
          pendidikan2: this.displayPendidikan ? this.pendidikan2 : undefined
        })
          .then(response => {
            const { status, message, data } = response.data;
            if (status) {
              this.visible = false;
              const url = data;
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", data.split("/").pop());
              document.body.appendChild(link);
              link.click();
            } else {
              this.$store.commit("snackbar/setSnack", {
                show: true,
                message: message,
                color: "error"
              });
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingExport = false));
      } catch (err) {
        console.error(err);
      }
    }
  },
  mounted() {
    this.getListUnit();
    this.getKelompokJabatanListAll();
    this.getPendidikanList();
  }
};
</script>
